import { StandardStrapiFields } from '../strapi/strapi'
import FormOrder from './form-order'
import FormSet from './form-set'

export default interface Form extends StandardStrapiFields {
    color?: string // hex цвета
    colorName?: string // название цвета
    dateOfFailure?: string
    form_set?: FormSet // набор к которому относится форма
    form_order?: FormOrder // заказ к которому относится форма
    inStock?: boolean // признак того, что форма в наличии
    num?: string // номер формы, созданный синтетически: год-id form set-id order
    oldNum?: string // старый номер формы, по началу надо как то занести все формы в систему
    failureReason?: FailureReason
    polymer?: Polymer
}

export enum FailureReason {
    ManufacturingDefect = 'Брак прихода',
    Breakage = 'Поломка',
}

export enum Polymer {
    Kodak = 'Кодак',
    KodakAnalog = 'Аналог Кодака',
    Chinese = 'Китайский',
    Soft = 'Мягкий',
}
